<template>
  <div v-show="value" class="vue-image-crop-upload">
    <div class="vicp-wrap">
      <div class="daloagBox">
        <span>图片上传</span>
        <div class="vicp-close" @click="off">
          <i class="el-dialog__close el-icon el-icon-close"/>
        </div>
      </div>
      <div v-show="step == 1" class="vicp-step1">
        <div class="vicp-drop-area" @dragleave="preventDefault" @dragover="preventDefault" @dragenter="preventDefault" @click="handleClick" @drop="handleChange">
          <!--<i v-show="loading != 1" class="vicp-icon1">
            <i class="vicp-icon1-arrow"/>
            <i class="vicp-icon1-body"/>
            <i class="vicp-icon1-bottom"/>
          </i>
          <span v-show="loading !== 1" class="vicp-hint">{{ lang.hint }}</span>
          <span v-show="!isSupported" class="vicp-no-supported-hint">{{ lang.noSupported }}</span>-->
          <div v-show="loading != 1" style="line-height: 0" >
            <img src="data:image/png;base64,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" alt="">
          </div>
          <input v-show="false" v-if="step == 1" ref="fileinput" type="file" @change="handleChange">
        </div>
        <div v-show="hasError" class="vicp-error">
          <i class="vicp-icon2"/> {{ errorMsg }}
        </div>
        <div class="vicp-operate">
          <a @click="off" @mousedown="ripple">{{ lang.btn.off }}</a>
        </div>
      </div>

      <div v-if="step == 2" class="vicp-step2">
        <div class="vicp-crop">
          <div v-show="true" class="vicp-crop-left">
            <div class="vicp-img-container">
              <img
                ref="img"
                :src="sourceImgUrl"
                :style="sourceImgStyle"
                class="vicp-img"
                draggable="false"
                @drag="preventDefault"
                @dragstart="preventDefault"
                @dragend="preventDefault"
                @dragleave="preventDefault"
                @dragover="preventDefault"
                @dragenter="preventDefault"
                @drop="preventDefault"
                @touchstart="imgStartMove"
                @touchmove="imgMove"
                @touchend="createImg"
                @touchcancel="createImg"
                @mousedown="imgStartMove"
                @mousemove="imgMove"
                @mouseup="createImg"
                @mouseout="createImg">
              <div :style="sourceImgShadeStyle" class="vicp-img-shade vicp-img-shade-1"/>
              <div :style="sourceImgShadeStyle" class="vicp-img-shade vicp-img-shade-2"/>
            </div>

            <div class="vicp-range">
              <input :value="scale.range" type="range" step="1" min="0" max="100" @mousemove="zoomChange">
              <i class="vicp-icon5" @mousedown="startZoomSub" @mouseout="endZoomSub" @mouseup="endZoomSub"/>
              <i class="vicp-icon6" @mousedown="startZoomAdd" @mouseout="endZoomAdd" @mouseup="endZoomAdd"/>
            </div>

            <div v-if="!noRotate" class="vicp-rotate">
              <i @click="rotateImg">↻</i>
            </div>
          </div>
          <div v-show="true" class="vicp-crop-right">
            <div class="vicp-preview">
              <div v-if="!noSquare" class="vicp-preview-item">
                <img :src="createImgUrl" :style="previewStyle">
                <span>{{ lang.preview }}</span>
              </div>
              <div v-if="!noCircle" class="vicp-preview-item vicp-preview-item-circle">
                <img :src="createImgUrl" :style="previewStyle">
                <span>{{ lang.preview }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vicp-operate">
          <a @click="setStep(1)" @mousedown="ripple">{{ lang.btn.back }}</a>
          <a class="vicp-operate-btn" @click="prepareUpload" @mousedown="ripple">{{ lang.btn.save }}</a>
        </div>
      </div>

      <div v-if="step == 3" class="vicp-step3">
        <div class="vicp-upload">
          <span v-show="loading === 1" class="vicp-loading">{{ lang.loading }}</span>
          <div class="vicp-progress-wrap">
            <span v-show="loading === 1" :style="progressStyle" class="vicp-progress"/>
          </div>
          <div v-show="hasError" class="vicp-error">
            <i class="vicp-icon2"/> {{ errorMsg }}
          </div>
          <div v-show="loading === 2" class="vicp-success">
            <i class="vicp-icon3"/> {{ lang.success }}
          </div>
        </div>
        <div class="vicp-operate">
          <a @click="setStep(2)" @mousedown="ripple">{{ lang.btn.back }}</a>
          <a @click="off" @mousedown="ripple">{{ lang.btn.close }}</a>
        </div>
      </div>
      <canvas v-show="false" ref="canvas" :width="width" :height="height"/>
    </div>
  </div>
</template>

<script>
'use strict'
import language from './language.js'
import mimes from './mimes.js'
import data2blob from './data2blob.js'
import effectRipple from './effectRipple.js'
/* eslint-disable */

  export default {
    props: {
      // 域，上传文件name，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
      field: {
        type: String,
        'default': 'avatar'
      },
      // 原名key，类似于id，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
      ki: {
        'default': 0
      },
      // 显示该控件与否
      value: {
        'default': true
      },
      // 上传地址
      url: {
        type: String,
        'default': ''
      },
      // 其他要上传文件附带的数据，对象格式
      params: {
        type: Object,
        'default': null
      },
      // Add custom headers
      headers: {
        type: Object,
        'default': null
      },
      // 剪裁图片的宽
      width: {
        type: Number,
        default: 200
      },
      // 剪裁图片的高
      height: {
        type: Number,
        default: 200
      },
      // 不显示旋转功能
      noRotate: {
        type: Boolean,
        default: true
      },
      // 不预览圆形图片
      noCircle: {
        type: Boolean,
        default: false
      },
      // 不预览方形图片
      noSquare: {
        type: Boolean,
        default: false
      },
      // 单文件大小限制
      maxSize: {
        type: Number,
        'default': 10240
      },
      // 语言类型
      langType: {
        type: String,
        'default': 'zh'
      },
      // 语言包
      langExt: {
        type: Object,
        'default': null
      },
      // 图片上传格式
      imgFormat: {
        type: String,
        'default': 'png'
      },
      // 图片背景 jpg情况下生效
      imgBgc: {
        type: String,
        'default': '#fff'
      },
      // 是否支持跨域
      withCredentials: {
        type: Boolean,
        'default': false
      },
      method: {
        type: String,
        'default': 'POST'
      }
    },
    data() {
      let that = this,
        {
          imgFormat,
          langType,
          langExt,
          width,
          height
        } = that,
        isSupported = true,
        allowImgFormat = [
          'jpg',
          'png'
        ],
        tempImgFormat = allowImgFormat.indexOf(imgFormat) === -1 ? 'jpg' : imgFormat,
        lang = language[langType] ? language[langType] : language['zh'],
        mime = mimes[tempImgFormat]
      // 规范图片格式
      that.imgFormat = tempImgFormat

      if (langExt) {
        Object.assign(lang, langExt)
      }
      if (typeof FormData !== 'function') {
        isSupported = false
      }
      return {
        // 图片的mime
        mime,

        // 语言包
        lang,

        // 浏览器是否支持该控件
        isSupported,
        // 浏览器是否支持触屏事件
        // isSupportTouch: document.hasOwnProperty('ontouchstart'),

        // 步骤
        step: 1, // 1选择文件 2剪裁 3上传

        // 上传状态及进度
        loading: 0, // 0未开始 1正在 2成功 3错误
        progress: 0,

        // 是否有错误及错误信息
        hasError: false,
        errorMsg: '',

        // 需求图宽高比
        ratio: width / height,

        // 原图地址、生成图片地址
        sourceImg: null,
        sourceImgUrl: '',
        createImgUrl: '',

        // 原图片拖动事件初始值
        sourceImgMouseDown: {
          on: false,
          mX: 0, // 鼠标按下的坐标
          mY: 0,
          x: 0, // scale原图坐标
          y: 0
        },

        // 生成图片预览的容器大小
        previewContainer: {
          width: 100,
          height: 100
        },

        // 原图容器宽高
        sourceImgContainer: { // sic
          width: 240,
          height: 184 // 如果生成图比例与此一致会出现bug，先改成特殊的格式吧，哈哈哈
        },

        // 原图展示属性
        scale: {
          zoomAddOn: false, // 按钮缩放事件开启
          zoomSubOn: false, // 按钮缩放事件开启
          range: 1, // 最大100

          x: 0,
          y: 0,
          width: 0,
          height: 0,
          maxWidth: 0,
          maxHeight: 0,
          minWidth: 0, // 最宽
          minHeight: 0,
          naturalWidth: 0, // 原宽
          naturalHeight: 0
        }
      }
    },
    computed: {
      // 进度条样式
      progressStyle() {
        const {
          progress
        } = this
        return {
          width: progress + '%'
        }
      },
      // 原图样式
      sourceImgStyle() {
        let {
            scale,
            sourceImgMasking
          } = this,
          top = scale.y + sourceImgMasking.y + 'px',
          left = scale.x + sourceImgMasking.x + 'px'
        return {
          top,
          left,
          width: scale.width + 'px',
          height: scale.height + 'px'// 兼容 Opera
        }
      },
      // 原图蒙版属性
      sourceImgMasking() {
        let {
            width,
            height,
            ratio,
            sourceImgContainer
          } = this,
          sic = sourceImgContainer,
          sicRatio = sic.width / sic.height, // 原图容器宽高比
          x = 0,
          y = 0,
          w = sic.width,
          h = sic.height,
          scale = 1
        if (ratio < sicRatio) {
          scale = sic.height / height
          w = sic.height * ratio
          x = (sic.width - w) / 2
        }
        if (ratio > sicRatio) {
          scale = sic.width / width
          h = sic.width / ratio
          y = (sic.height - h) / 2
        }
        return {
          scale, // 蒙版相对需求宽高的缩放
          x,
          y,
          width: w,
          height: h
        }
      },
      // 原图遮罩样式
      sourceImgShadeStyle() {
        let {
            sourceImgMasking,
            sourceImgContainer
          } = this,
          sic = sourceImgContainer,
          sim = sourceImgMasking,
          w = sim.width == sic.width ? sim.width : (sic.width - sim.width) / 2,
          h = sim.height == sic.height ? sim.height : (sic.height - sim.height) / 2
        return {
          width: w + 'px',
          height: h + 'px'
        }
      },
      previewStyle() {
        let {
            width,
            height,
            ratio,
            previewContainer
          } = this,
          pc = previewContainer,
          w = pc.width,
          h = pc.height,
          pcRatio = w / h
        if (ratio < pcRatio) {
          w = pc.height * ratio
        }
        if (ratio > pcRatio) {
          h = pc.width / ratio
        }
        return {
          width: w + 'px',
          height: h + 'px'
        }
      }
    },
    watch: {
      value(newValue) {
        if (newValue && this.loading != 1) {
          this.reset()
        }
      }
    },
    mounted() {
      // 绑定按键esc隐藏此插件事件
      document.addEventListener('keyup', (e) => {
        if (this.value && (e.key == 'Escape' || e.keyCode == 27)) {
          this.off()
        }
      })
    },
    methods: {
      // 点击波纹效果
      ripple(e) {
        effectRipple(e)
      },
      // 关闭控件
      off() {
        setTimeout(() => {
          this.$emit('input', false)
          if (this.step == 3 && this.loading == 2) {
            this.setStep(1)
          }
        }, 200)
      },
      // 设置步骤
      setStep(no) {
        // 延时是为了显示动画效果呢，哈哈哈
        setTimeout(() => {
          this.step = no
        }, 200)
      },

      /* 图片选择区域函数绑定
             ---------------------------------------------------------------*/
      preventDefault(e) {
        e.preventDefault()
        return false
      },
      handleClick(e) {
        if (this.loading !== 1) {
          if (e.target !== this.$refs.fileinput) {
            e.preventDefault()
            if (document.activeElement !== this.$refs) {
              this.$refs.fileinput.click()
            }
          }
        }
      },
      handleChange(e) {
        e.preventDefault()
        if (this.loading !== 1) {
          const files = e.target.files || e.dataTransfer.files
          this.reset()
          if (this.checkFile(files[0])) {
            this.setSourceImg(files[0])
          }
        }
      },
      /* ---------------------------------------------------------------*/

      // 检测选择的文件是否合适
      checkFile(file) {
        let that = this,
          {
            lang,
            maxSize
          } = that
        // 仅限图片
        if (file.type.indexOf('image') === -1) {
          that.hasError = true
          that.errorMsg = lang.error.onlyImg
          return false
        }

        // 超出大小
        if (file.size / 1024 > maxSize) {
          that.hasError = true
          that.errorMsg = lang.error.outOfSize + maxSize + 'kb'
          return false
        }
        return true
      },
      // 重置控件
      reset() {
        const that = this
        that.loading = 0
        that.hasError = false
        that.errorMsg = ''
        that.progress = 0
      },
      // 设置图片源
      setSourceImg(file) {
        this.$emit('src-file-set', file.name, file.type, file.size)
        let that = this,
          fr = new FileReader()
        fr.onload = function(e) {
          that.sourceImgUrl = fr.result
          that.startCrop()
        }
        fr.readAsDataURL(file)
      },
      // 剪裁前准备工作
      startCrop() {
        let that = this,
          {
            width,
            height,
            ratio,
            scale,
            sourceImgUrl,
            sourceImgMasking,
            lang
          } = that,
          sim = sourceImgMasking,
          img = new Image()
        img.src = sourceImgUrl
        img.onload = function() {
          let nWidth = img.naturalWidth,
            nHeight = img.naturalHeight,
            nRatio = nWidth / nHeight,
            w = sim.width,
            h = sim.height,
            x = 0,
            y = 0
          // 图片像素不达标
          if (nWidth < width || nHeight < height) {
            that.hasError = true
            that.errorMsg = lang.error.lowestPx + width + '*' + height
            return false
          }
          if (ratio > nRatio) {
            h = w / nRatio
            y = (sim.height - h) / 2
          }
          if (ratio < nRatio) {
            w = h * nRatio
            x = (sim.width - w) / 2
          }
          scale.range = 0
          scale.x = x
          scale.y = y
          scale.width = w
          scale.height = h
          scale.minWidth = w
          scale.minHeight = h
          scale.maxWidth = nWidth * sim.scale
          scale.maxHeight = nHeight * sim.scale
          scale.naturalWidth = nWidth
          scale.naturalHeight = nHeight
          that.sourceImg = img
          that.createImg()
          that.setStep(2)
        }
      },
      // 鼠标按下图片准备移动
      imgStartMove(e) {
        e.preventDefault()
        // 支持触摸事件，则鼠标事件无效
        if (this.isSupportTouch && !e.targetTouches) {
          return false
        }
        let et = e.targetTouches ? e.targetTouches[0] : e,
          {
            sourceImgMouseDown,
            scale
          } = this,
          simd = sourceImgMouseDown
        simd.mX = et.screenX
        simd.mY = et.screenY
        simd.x = scale.x
        simd.y = scale.y
        simd.on = true
      },
      // 鼠标按下状态下移动，图片移动
      imgMove(e) {
        e.preventDefault()
        // 支持触摸事件，则鼠标事件无效
        if (this.isSupportTouch && !e.targetTouches) {
          return false
        }
        let et = e.targetTouches ? e.targetTouches[0] : e,
          {
            sourceImgMouseDown: {
              on,
              mX,
              mY,
              x,
              y
            },
            scale,
            sourceImgMasking
          } = this,
          sim = sourceImgMasking,
          nX = et.screenX,
          nY = et.screenY,
          dX = nX - mX,
          dY = nY - mY,
          rX = x + dX,
          rY = y + dY
        if (!on) return
        if (rX > 0) {
          rX = 0
        }
        if (rY > 0) {
          rY = 0
        }
        if (rX < sim.width - scale.width) {
          rX = sim.width - scale.width
        }
        if (rY < sim.height - scale.height) {
          rY = sim.height - scale.height
        }
        scale.x = rX
        scale.y = rY
      },
      // 顺时针旋转图片
      rotateImg(e) {
        let {
            sourceImg,
            scale: {
              naturalWidth,
              naturalHeight
            }
          } = this,
          width = naturalHeight,
          height = naturalWidth,
          canvas = this.$refs.canvas,
          ctx = canvas.getContext('2d')
        canvas.width = width
        canvas.height = height
        ctx.clearRect(0, 0, width, height)

        ctx.fillStyle = 'rgba(0,0,0,0)'
        ctx.fillRect(0, 0, width, height)

        ctx.translate(width, 0)
        ctx.rotate(Math.PI * 90 / 180)

        ctx.drawImage(sourceImg, 0, 0, naturalWidth, naturalHeight)
        const imgUrl = canvas.toDataURL(mimes['png'])

        this.sourceImgUrl = imgUrl
        this.startCrop()
      },

      // 按钮按下开始放大
      startZoomAdd(e) {
        let that = this,
          {
            scale
          } = that
        scale.zoomAddOn = true

        function zoom() {
          if (scale.zoomAddOn) {
            const range = scale.range >= 100 ? 100 : ++scale.range
            that.zoomImg(range)
            setTimeout(function() {
              zoom()
            }, 60)
          }
        }
        zoom()
      },
      // 按钮松开或移开取消放大
      endZoomAdd(e) {
        this.scale.zoomAddOn = false
      },
      // 按钮按下开始缩小
      startZoomSub(e) {
        let that = this,
          {
            scale
          } = that
        scale.zoomSubOn = true

        function zoom() {
          if (scale.zoomSubOn) {
            const range = scale.range <= 0 ? 0 : --scale.range
            that.zoomImg(range)
            setTimeout(function() {
              zoom()
            }, 60)
          }
        }
        zoom()
      },
      // 按钮松开或移开取消缩小
      endZoomSub(e) {
        const {
          scale
        } = this
        scale.zoomSubOn = false
      },
      zoomChange(e) {
        this.zoomImg(e.target.value)
      },
      // 缩放原图
      zoomImg(newRange) {
        let that = this,
          {
            sourceImgMasking,
            sourceImgMouseDown,
            scale
          } = this,
          {
            maxWidth,
            maxHeight,
            minWidth,
            minHeight,
            width,
            height,
            x,
            y,
            range
          } = scale,
          sim = sourceImgMasking,
          // 蒙版宽高
          sWidth = sim.width,
          sHeight = sim.height,
          // 新宽高
          nWidth = minWidth + (maxWidth - minWidth) * newRange / 100,
          nHeight = minHeight + (maxHeight - minHeight) * newRange / 100,
          // 新坐标（根据蒙版中心点缩放）
          nX = sWidth / 2 - (nWidth / width) * (sWidth / 2 - x),
          nY = sHeight / 2 - (nHeight / height) * (sHeight / 2 - y)

        // 判断新坐标是否超过蒙版限制
        if (nX > 0) {
          nX = 0
        }
        if (nY > 0) {
          nY = 0
        }
        if (nX < sWidth - nWidth) {
          nX = sWidth - nWidth
        }
        if (nY < sHeight - nHeight) {
          nY = sHeight - nHeight
        }

        // 赋值处理
        scale.x = nX
        scale.y = nY
        scale.width = nWidth
        scale.height = nHeight
        scale.range = newRange
        setTimeout(function() {
          if (scale.range == newRange) {
            that.createImg()
          }
        }, 300)
      },
      // 生成需求图片
      createImg(e) {
        let that = this,
          {
            imgFormat,
            imgBgc,
            mime,
            sourceImg,
            scale: {
              x,
              y,
              width,
              height
            },
            sourceImgMasking: {
              scale
            }
          } = that,
          canvas = that.$refs.canvas,
          ctx = canvas.getContext('2d')
        if (e) {
          // 取消鼠标按下移动状态
          that.sourceImgMouseDown.on = false
        }
        canvas.width = that.width
        canvas.height = that.height
        ctx.clearRect(0, 0, that.width, that.height)

        if (imgFormat == 'png') {
          ctx.fillStyle = 'rgba(0,0,0,0)'
        } else {
          // 如果jpg 为透明区域设置背景，默认白色
          ctx.fillStyle = imgBgc
        }
        ctx.fillRect(0, 0, that.width, that.height)

        ctx.drawImage(sourceImg, x / scale, y / scale, width / scale, height / scale)
        that.createImgUrl = canvas.toDataURL(mime)
      },
      prepareUpload() {
        const {
          url,
          createImgUrl,
          field,
          ki
        } = this
        this.$emit('crop-success', createImgUrl, field, ki)
        if (typeof url === 'string' && url) {
          this.upload()
        } else {
          this.reset()
          this.setStep(1)
          this.off()
        }
      },
      // 上传图片
      upload() {
        let that = this,
          {
            lang,
            imgFormat,
            mime,
            url,
            params,
            headers,
            field,
            ki,
            createImgUrl,
            withCredentials,
            method
          } = this,
          fmData = new FormData()
        fmData.append(field, data2blob(createImgUrl, mime), field + '.' + imgFormat)

        // 添加其他参数
        if (typeof params === 'object' && params) {
          Object.keys(params).forEach((k) => {
            fmData.append(k, params[k])
          })
        }

        // 监听进度回调
        const uploadProgress = function(event) {
          if (event.lengthComputable) {
            that.progress = 100 * Math.round(event.loaded) / event.total
          }
        }

        // 上传文件
        that.reset()
        that.loading = 1
        that.setStep(3)
        new Promise(function(resolve, reject) {
          const client = new XMLHttpRequest()
          client.open(method, url, true)
          client.withCredentials = withCredentials
          client.onreadystatechange = function() {
            if (this.readyState !== 4) {
              return
            }
            if (this.status === 200 || this.status === 201) {
              resolve(JSON.parse(this.responseText))
            } else {
              reject(this.status)
            }
          }
          client.upload.addEventListener('progress', uploadProgress, false) // 监听进度
          // 设置header
          if (typeof headers === 'object' && headers) {
            Object.keys(headers).forEach((k) => {
              client.setRequestHeader(k, headers[k])
            })
          }
          client.send(fmData)
        }).then(
          // 上传成功
          function(resData) {
            if (that.value) {
              that.loading = 2
              that.$emit('crop-upload-success', resData, field, ki)
              that.off()
            }
          },
          // 上传失败
          function(sts) {
            if (that.value) {
              that.loading = 3
              that.hasError = true
              that.errorMsg = lang.fail
              that.$emit('crop-upload-fail', sts, field, ki)
            }
          }
        )
      }
    }
  }

</script>

<!--
<style lang='sass' src="./scss/upload.scss">
</style> -->

<style>
  @charset "UTF-8";
  @-webkit-keyframes vicp_progress {
    0% {
      background-position-y: 0; }
    100% {
      background-position-y: 40px; } }
  @keyframes vicp_progress {
    0% {
      background-position-y: 0; }
    100% {
      background-position-y: 40px; } }

  @-webkit-keyframes vicp {
    0% {
      opacity: 0;
      -webkit-transform: scale(0) translatey(-60px);
      transform: scale(0) translatey(-60px); }
    100% {
      opacity: 1;
      -webkit-transform: scale(1) translatey(0);
      transform: scale(1) translatey(0); } }

  @keyframes vicp {
    0% {
      opacity: 0;
      -webkit-transform: scale(0) translatey(-60px);
      transform: scale(0) translatey(-60px); }
    100% {
      opacity: 1;
      -webkit-transform: scale(1) translatey(0);
      transform: scale(1) translatey(0); } }

  .daloagBox{
    height: 55px;
    line-height: 55px;
    margin-bottom: 10px;
    color: #303133;
    font-size: 18px;
  }
  .vue-image-crop-upload {
    position: fixed;
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 10000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.65);
    -webkit-tap-highlight-color: transparent;
    -moz-tap-highlight-color: transparent; }
  .vue-image-crop-upload .vicp-wrap {
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    position: fixed;
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 10000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 600px;
    height: 330px;
    padding: 0 25px 25px;
    background-color: #fff;
    border-radius: 2px;
    -webkit-animation: vicp 0.12s ease-in;
    animation: vicp 0.12s ease-in; }
  .vue-image-crop-upload .vicp-wrap .vicp-close {
    position: absolute;
    right: 0;
    text-align: center;
    width: 55px;
    top: 0;
    cursor: pointer;
  }
  .vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4 {
    position: relative;
    display: block;
    width: 30px;
    height: 30px;
    cursor: pointer;
    -webkit-transition: -webkit-transform 0.18s;
    transition: -webkit-transform 0.18s;
    transition: transform 0.18s;
    transition: transform 0.18s, -webkit-transform 0.18s;
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    transform: rotate(0); }
  .vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4::after, .vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4::before {
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    content: '';
    position: absolute;
    top: 12px;
    left: 4px;
    width: 20px;
    height: 3px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    background-color: #fff; }
  .vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4::after {
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg); }
  .vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4:hover {
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg); }
  .vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area {
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 35px;
    border-radius: 6px;
    height: 170px;
    background-color: #fff;
    text-align: center;
    border: 1px dashed #d9d9d9;
    overflow: hidden; }
  .vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 {
    display: block;
    margin: 0 auto 6px;
    width: 42px;
    height: 42px;
    overflow: hidden; }
  .vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 .vicp-icon1-arrow {
    display: block;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-bottom: 14.7px solid rgba(0, 0, 0, 0.3);
    border-left: 14.7px solid transparent;
    border-right: 14.7px solid transparent; }
  .vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 .vicp-icon1-body {
    display: block;
    width: 12.6px;
    height: 14.7px;
    margin: 0 auto;
    background-color: rgba(0, 0, 0, 0.3); }
  .vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 .vicp-icon1-bottom {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    height: 12.6px;
    border: 6px solid rgba(0, 0, 0, 0.3);
    border-top: none; }
  .vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-hint {
    display: block;
    padding: 15px;
    font-size: 14px;
    color: #666;
    line-height: 30px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-no-supported-hint {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    padding: 30px;
    width: 100%;
    height: 60px;
    line-height: 30px;
    background-color: #eee;
    text-align: center;
    color: #666;
    font-size: 14px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area:hover {
    cursor: pointer;
    border-color:#409EFF;
  }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop {
    overflow: hidden; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left {
    float: left; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container {
    position: relative;
    display: block;
    width: 240px;
    height: 180px;
    background-color: #e5e5e0;
    overflow: hidden; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img {
    position: absolute;
    display: block;
    cursor: move;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img-shade {
    -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    position: absolute;
    background-color: rgba(241, 242, 243, 0.8); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img-shade.vicp-img-shade-1 {
    top: 0;
    left: 0; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img-shade.vicp-img-shade-2 {
    bottom: 0;
    right: 0; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate {
    position: relative;
    width: 240px;
    height: 18px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i {
    display: block;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    line-height: 18px;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    background-color: rgba(0, 0, 0, 0.08);
    color: #fff;
    overflow: hidden; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i:hover {
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.14); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i:first-child {
    float: left; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i:last-child {
    float: right; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range {
    position: relative;
    margin: 30px 0 10px 0;
    width: 240px;
    height: 18px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5,
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6 {
    position: absolute;
    top: 0;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    background-color: rgba(0, 0, 0, 0.08); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5:hover,
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6:hover {
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.14); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5 {
    left: 0; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5::before {
    position: absolute;
    content: '';
    display: block;
    left: 3px;
    top: 8px;
    width: 12px;
    height: 2px;
    background-color: #fff; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6 {
    right: 0; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6::before {
    position: absolute;
    content: '';
    display: block;
    left: 3px;
    top: 8px;
    width: 12px;
    height: 2px;
    background-color: #fff; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6::after {
    position: absolute;
    content: '';
    display: block;
    top: 3px;
    left: 8px;
    width: 2px;
    height: 12px;
    background-color: #fff; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range] {
    display: block;
    padding-top: 5px;
    margin: 0 auto;
    width: 180px;
    height: 8px;
    vertical-align: top;
    background: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    /* 滑块
                     ---------------------------------------------------------------*/
    /* 轨道
                     ---------------------------------------------------------------*/ }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus {
    outline: none; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-thumb {
    -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    -webkit-appearance: none;
    appearance: none;
    margin-top: -3px;
    width: 12px;
    height: 12px;
    background-color: rgb(48, 151, 255);
    border-radius: 100%;
    border: none;
    -webkit-transition: 0.2s;
    transition: 0.2s; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-moz-range-thumb {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    -moz-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    background-color: rgba(48, 151, 255, 0.54);
    border-radius: 100%;
    border: none;
    -webkit-transition: 0.2s;
    transition: 0.2s; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-thumb {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    appearance: none;
    width: 12px;
    height: 12px;
    background-color: rgba(48, 151, 255, 0.54);
    border: none;
    border-radius: 100%;
    -webkit-transition: 0.2s;
    transition: 0.2s; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-moz-range-thumb {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    width: 14px;
    height: 14px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-ms-thumb {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    width: 14px;
    height: 14px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-webkit-slider-thumb {
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    margin-top: -4px;
    width: 14px;
    height: 14px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-runnable-track {
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    width: 100%;
    height: 6px;
    cursor: pointer;
    border-radius: 2px;
    border: none;
    background-color: rgba(48, 151, 255, 0.3); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-moz-range-track {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    width: 100%;
    height: 6px;
    cursor: pointer;
    border-radius: 2px;
    border: none;
    background-color: rgba(48, 151, 255, 0.3); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-track {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    width: 100%;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
    height: 6px;
    border-radius: 2px;
    border: none; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-lower {
    background-color: rgba(48, 151, 255, 0.3); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-upper {
    background-color: rgba(48, 151, 255, 0.15); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-webkit-slider-runnable-track {
    background-color: rgba(48, 151, 255, 0.5); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-moz-range-track {
    background-color: rgba(48, 151, 255, 0.5); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-lower {
    background-color: rgba(48, 151, 255, 0.45); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-upper {
    background-color: rgba(48, 151, 255, 0.25); }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right {
    float: right; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview {
    height: 150px;
    overflow: hidden; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item {
    position: relative;
    padding: 5px;
    width: 100px;
    height: 100px;
    float: left;
    margin-right: 16px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item span {
    position: absolute;
    bottom: -30px;
    width: 100%;
    font-size: 14px;
    color: #999;
    display: block;
    text-align: center;
    line-height: 20px;
  }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item img {
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding: 3px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item.vicp-preview-item-circle {
    margin-right: 0; }
  .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item.vicp-preview-item-circle img {
    border-radius: 100%; }
  .vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload {
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 35px;
    height: 170px;
    background-color: rgba(0, 0, 0, 0.03);
    text-align: center;
    border: 1px dashed #ddd; }
  .vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-loading {
    display: block;
    padding: 15px;
    font-size: 16px;
    color: #999;
    line-height: 30px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-progress-wrap {
    margin-top: 12px;
    background-color: rgba(0, 0, 0, 0.08);
    border-radius: 3px; }
  .vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-progress-wrap .vicp-progress {
    position: relative;
    display: block;
    height: 5px;
    border-radius: 3px;
    background-color: #659be6;
    -webkit-box-shadow: 0 2px 6px 0 rgba(48, 151, 255, 0.3);
    box-shadow: 0 2px 6px 0 rgba(48, 151, 255, 0.3);
    -webkit-transition: width 0.15s linear;
    transition: width 0.15s linear;
    background-image: -webkit-linear-gradient(135deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);
    background-image: linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);
    background-size: 40px 40px;
    -webkit-animation: vicp_progress 0.5s linear infinite;
    animation: vicp_progress 0.5s linear infinite; }
  .vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-progress-wrap .vicp-progress::after {
    content: '';
    position: absolute;
    display: block;
    top: -3px;
    right: -3px;
    width: 9px;
    height: 9px;
    border: 1px solid rgba(245, 246, 247, 0.7);
    -webkit-box-shadow: 0 1px 4px 0 rgba(48, 151, 255, 0.7);
    box-shadow: 0 1px 4px 0 rgba(48, 151, 255, 0.7);
    border-radius: 100%;
    background-color: #659be6; }
  .vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-error,
  .vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-success {
    height: 100px;
    line-height: 100px; }
  .vue-image-crop-upload .vicp-wrap .vicp-operate {
    position: absolute;
    right: 20px;
    bottom: 20px; }
  .vue-image-crop-upload .vicp-wrap .vicp-operate a {
    position: relative;
    float: left;
    display: block;
    margin-left: 10px;
    width: 100px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    color: #659be6;
    border-radius: 2px;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; }
  .vue-image-crop-upload .vicp-wrap .vicp-operate a:hover {
    background-color: rgba(0, 0, 0, 0.03); }
  .vue-image-crop-upload .vicp-wrap .vicp-error,
  .vue-image-crop-upload .vicp-wrap .vicp-success {
    display: block;
    font-size: 14px;
    line-height: 24px;
    height: 24px;
    color: #d10;
    text-align: center;
    vertical-align: top; }
  .vue-image-crop-upload .vicp-wrap .vicp-success {
    color: #659be6; }
  .vue-image-crop-upload .vicp-wrap .vicp-icon3 {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    top: 4px; }
  .vue-image-crop-upload .vicp-wrap .vicp-icon3::after {
    position: absolute;
    top: 3px;
    left: 6px;
    width: 6px;
    height: 10px;
    border-width: 0 2px 2px 0;
    border-color: #659be6;
    border-style: solid;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    content: ''; }
  .vue-image-crop-upload .vicp-wrap .vicp-icon2 {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    top: 4px; }
  .vue-image-crop-upload .vicp-wrap .vicp-icon2::after, .vue-image-crop-upload .vicp-wrap .vicp-icon2::before {
    content: '';
    position: absolute;
    top: 9px;
    left: 4px;
    width: 13px;
    height: 2px;
    background-color: #d10;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg); }
  .vue-image-crop-upload .vicp-wrap .vicp-icon2::after {
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg); }

  .e-ripple {
    position: absolute;
    border-radius: 100%;
    background-color: rgba(0, 0, 0, 0.15);
    background-clip: padding-box;
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
    opacity: 1; }
  .e-ripple.z-active {
    opacity: 0;
    -webkit-transform: scale(2);
    -ms-transform: scale(2);
    transform: scale(2);
    -webkit-transition: opacity 1.2s ease-out, -webkit-transform 0.6s ease-out;
    transition: opacity 1.2s ease-out, -webkit-transform 0.6s ease-out;
    transition: opacity 1.2s ease-out, transform 0.6s ease-out;
    transition: opacity 1.2s ease-out, transform 0.6s ease-out, -webkit-transform 0.6s ease-out; }

</style>
